import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import {
  getShoppingCarts,
  actions,
  isLoadingFetchShoppingCart,
  getFailureFetchShoppingCart,
  isSuccessFetchShoppingCart
} from "../modules/shoppingCart";
import _ from "lodash/fp";
import { selectors } from "../modules/customers";
import { getCurrentDealer } from "../modules/dealers";

const getId = _.getOr(null, "id");

const container = connect(
  state => ({
    shoppingCarts: getShoppingCarts(state),
    loading: isLoadingFetchShoppingCart(state),
    success: isSuccessFetchShoppingCart(state),
    failure: getFailureFetchShoppingCart(state),
    customerId: getId(selectors.getCurrentCustomer(state)),
    dealerId: getId(getCurrentDealer(state)),
    role: state.settings.role
  }),
  {
    fetchDealerShoppingCarts: actions.fetchDealerShoppingCarts,
    fetchCustomerShoppingCarts: actions.fetchCustomerShoppingCarts,
    resetState: actions.resetState
  }
);

export default function WithFetchShoppingCarts(WrappedComponent) {
  return container(function WrapperComponent(props) {
    const {
      resetState,
      shoppingCart,
      fetchDealerShoppingCarts,
      fetchCustomerShoppingCarts,
      dealerId,
      customerId,
      role
    } = props;

    const fetchShoppingCarts = useCallback(() => {
      if (role === "customer") {
        fetchCustomerShoppingCarts({ dealerId, customerId });
      } else if (role === "staff") {
        fetchDealerShoppingCarts({ dealerId });
      }
    }, [
      customerId,
      dealerId,
      fetchCustomerShoppingCarts,
      fetchDealerShoppingCarts,
      role
    ]);
    useEffect(() => {
      return () => {
        resetState(["shoppingCarts"]);
      };
    }, [resetState]);
    useEffect(() => {
      if (!shoppingCart) {
        fetchShoppingCarts();
      }
    }, [fetchShoppingCarts, shoppingCart]);
    return <WrappedComponent {...props} />;
  });
}
